import React, { memo, useCallback } from 'react';
import { CardView, Spacer, TextButtonLink } from 'design-system';
import Section from 'design-system/Section';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { useOpenCategory } from 'features/analytics/hooks/useOpenCategory';
import { selectExcludedParentCategories, selectMonthlyTotalsWithBudgets, selectPosition, } from '../selectors';
import UnbudgetedSpendRow from './UnbudgetedSpendRow';
const BudgetingExcludedCategoriesList = () => {
    const navigation = useMainStackNavigation();
    const categories = useAppSelector(selectExcludedParentCategories);
    const monthlyTotals = useAppSelector(selectMonthlyTotalsWithBudgets);
    const position = useAppSelector(selectPosition);
    const openCategory = useOpenCategory(monthlyTotals, position, 'Category');
    const onPressManage = useCallback(() => {
        navigation.navigateDeprecated('ExcludeCategories', {
            fromBudgeting: true,
        });
    }, []);
    if (!categories.length)
        return null;
    return (<>
      <Spacer.H16 />
      <Section title="Excluded categories" button={<TextButtonLink text="Manage" onPress={onPressManage}/>}>
        <CardView noMarginTop noMarginBottom webPadding>
          {categories.map((item) => {
            const onPress = () => openCategory({ data: item, type: 'category' });
            return (<UnbudgetedSpendRow key={item.id} category={item} onPress={onPress}/>);
        })}
        </CardView>
      </Section>
    </>);
};
export default memo(BudgetingExcludedCategoriesList);
